var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookActivity = function SvgFacebookActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 800 800"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1778F2",
    d: "M662.249 750h-524.75a83.75 83.75 0 0 1-62.5-25 83.75 83.75 0 0 1-25-62V137.5a83.75 83.75 0 0 1 25-62.5 83.75 83.75 0 0 1 62.5-25h525a83.75 83.75 0 0 1 62.5 25 83.76 83.76 0 0 1 25 62.5v525a88 88 0 0 1-87.75 87.5m-227-120.25V420h70.75l10.5-81.5h-81.25v-45.75a72 72 0 0 1 2.25-25 27.2 27.2 0 0 1 3.5-8.25c5.25-9.5 19-14.25 40.75-14.25h37.5V173.5a550 550 0 0 0-62.5-3.5 95.74 95.74 0 0 0-90.25 46.5 113 113 0 0 0-15.75 60v62h-70V420h69.25v209.75z"
  })));
};
export default SvgFacebookActivity;